import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from 'src/app/form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { environment } from 'src/environments/environment';
import { EnvironmentConfig } from 'src/environments/environmentConfig';
import * as CONSTANTS from '../../constants';

@Component({
  selector: 'time-horizon',
  templateUrl: './time-horizon.component.html',
  styleUrls: ['./time-horizon.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})

export class timeHorizonComponent implements OnInit {
  timeForm: any
  submitted: boolean = false;
  selectionY: boolean = null;
  selectionN: boolean = null;
  preQualObj: any;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  enumData: any;
  currentRoutePath: string;
  isIos: boolean;
  time_to_purchase: string;
  f: any;
  purchase: any;
  to: any;
  currentLang: string;
  validation: any;
  aboutForm: any;
  withinSix = "Within the next 6 months";
  morethanSix = "In 6 months or more";
  currLangEn = 'en';
  currLangFr = 'fr';
  constructor(private fb: FormBuilder,
    private _http: HttpClient,
    private changeDef: ChangeDetectorRef,
    private util: UtilService,
    private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private formUtiObj: FrameworkUtilityComponent,
    private router: Router) {

    this.isIos = !!navigator.platform && /iPad|iPhone|Mac|iPod/.test(navigator.platform);

    this.util.sidebarTitle.next('slideTitles.timeToPurchase');
    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();
    this.enumData = this.util.getEnumData();
  }

  ngOnInit(): void {
    document.getElementById("sidebarTitle").focus();
    this.currentLang = this.i18nService.getCurrentLang();
  }


  ngAfterViewInit() {
    if (this.isIos) {
      document.getElementById("sidebarTitle").focus();
    }
    else {
      document.getElementById("sidebarTitle").focus();

    }
  }

  onContinue() {
    this.submitted = true;

    if (!this.selectionY && !this.selectionN) {
      let temp = document.querySelector('[name="time-to-purchase"]') as HTMLInputElement;
      temp.focus();
      this.validation = true;
      return;
    }

    else {
      this.validation = false
    }
    this.preQualObj["time_to_purchase"] = this.time_to_purchase;
    this.util.setSessionStorage(this.preQualObj);

    this.util.saveJson(this.preQualObj).subscribe(response => {
    })
    if (this.time_to_purchase) {
      this._http.get(environment.api.getIpUrl).subscribe((res: any) => {

        this.util.setSessionStorage(this.preQualObj);


      }, (err) => {
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      });
    }
    this.router.navigate([this.util.determineNextRoute("time-to-purchase")], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    return;
  }


  buttonDisplay(selected) {

    if (selected == 'yes') {

      this.selectionY = true;
      this.selectionN = false;
      this.validation = false;
      this.time_to_purchase = this.withinSix;
    }

    if (selected == 'no') {
      this.selectionY = false;
      this.selectionN = true;
      this.validation = false;
      this.time_to_purchase = this.morethanSix;
    }

  }

}